import TopBanner from './top-banner';

export default TopBanner;
